import {
    DistributionController
} from 'controllers';


// functions
import { barcodify } from 'shared/functions';
import { getCountryCode } from 'shared/functions';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const getShipmentList = async (year, month, week, country) => {
    if (!year || !month) { return null };
    const monthNumber = barcodify(MONTHS.indexOf(month) + 1, 2);
    const countryCode = getCountryCode(country);
    const weekCode = week[0] + week[5];

    const result = await DistributionController.getShipmentListsByDate({ year, monthNumber, weekCode, countryCode });
    return result;
};
